import { axiosInstance as request } from '@api/rest.service'

const api = '/recent-actions'

/**
 * @description GET /recent-actions?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_RECENT_ACTIONS = params => request.get(`${api}?paginated=true`, { params })
